module.exports = __webpack_public_path__ + "img/goods.ced474e0.png";